export default __webpack_public_path__ + "static/media/feedback.b8f66f95.svg";